module.exports = __webpack_public_path__ + "img/volleyball.be5030ca.webp";